/**
 * IMPORTS
 */

import axios from "axios";

import { AppError } from "@/domain/errors/app-error";

/**
 * Coleta todas as mensagens de um objeto `errors` estilo Laravel/PHP.
 */
function handleCollectValidationMessagesLaravel(errors: Record<string, unknown>): string[] {
  const messages: string[] = [];

  for (const key of Object.keys(errors)) {
    const val = errors[key];
    if (Array.isArray(val)) {
      for (const item of val) {
        if (typeof item === "string") messages.push(item);
      }
    } else if (typeof val === "string") {
      messages.push(val);
    }
  }
  return messages;
}

/**
 * Normaliza o erro da API
 * @param data - Dados da resposta da API
 * @returns
 */
function handleNormalizeApiError(data: any): string {
  if (!data) return "Ocorreu um erro inesperado!";

  // Laravel / PHP: errors: { "campo.a": ["msg"], ... }
  if (data.errors && typeof data.errors === "object" && !Array.isArray(data.errors)) {
    const keys = Object.keys(data.errors);
    if (keys.length > 0) {
      const msgs = handleCollectValidationMessagesLaravel(data.errors as Record<string, unknown>);
      if (msgs.length > 0) {
        return msgs.join("\n");
      }
    }
  }

  if (data.errors?.message) {
    return data.errors.message;
  }

  if (data.message) {
    return data.message;
  }

  return "Ocorreu um erro inesperado!";
}

/**
 * Mensagem amigável a partir de AxiosError, AppError ou Error genérico.
 */
function getApiErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error) && error.response?.data !== undefined) {
    return handleNormalizeApiError(error.response.data);
  }
  if (error instanceof AppError) {
    if (error.responseData !== undefined) {
      return handleNormalizeApiError(error.responseData);
    }
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Ocorreu um erro inesperado!";
}

/**
 * Obtém o status HTTP da resposta da API
 * @param error - Erro a ser normalizado
 * @returns Status HTTP ou undefined
 */
function getApiErrorHttpStatus(error: unknown): number | undefined {
  if (axios.isAxiosError(error)) return error.response?.status;
  if (error instanceof AppError) return error.statusCode;
  return undefined;
}

/**
 * Obtém o payload da resposta da API
 * @param error - Erro a ser normalizado
 * @returns Payload da resposta da API ou undefined
 */
function getApiErrorResponsePayload(error: unknown): unknown {
  if (axios.isAxiosError(error)) return error.response?.data;
  if (error instanceof AppError) return error.responseData;
  return undefined;
}

/**
 * EXPORTS
 */
export {
  getApiErrorHttpStatus,
  getApiErrorMessage,
  getApiErrorResponsePayload,
  handleNormalizeApiError,
};
